import ScenePreview, { ScenePreviewSettings } from './ScenePreview';
import { noop } from 'utils/noop';
import { getSize } from 'utils/konva';

export default class ImageScenePreview extends ScenePreview<HTMLImageElement> {
  constructor(settings: ScenePreviewSettings, createImage = () => new Image()) {
    super();
    this.element = createImage();
    this.updateSettings(settings);
  }

  updateVolume() {
    noop();
  }

  updateSpecificSettings() {
    this.element.src = this.settings.src;
  }

  drawFrame(ctx: CanvasRenderingContext2D) {
    try {
      const [width, height] = getSize(
        this.settings.scalingMode,
        ctx.canvas.width,
        ctx.canvas.height,
        this.element.naturalWidth,
        this.element.naturalHeight
      );

      ctx.drawImage(
        this.element,
        (ctx.canvas.width - width) / 2,
        (ctx.canvas.height - height) / 2,
        width,
        height
      );
    } catch (e) {
      // eslint-disable-next-line
    }
  }

  getOriginalWidth() {
    return this.element.naturalWidth;
  }

  getOriginalHeight() {
    return this.element.naturalHeight;
  }

  getSize(ctx: CanvasRenderingContext2D) {
    return getSize(
      this.settings.scalingMode,
      ctx.canvas.width,
      ctx.canvas.height,
      this.element.naturalWidth,
      this.element.naturalHeight
    );
  }
}
